import { render } from "./InterconsultaForm.vue?vue&type=template&id=0ac11e51&scoped=true"
import script from "./InterconsultaForm.vue?vue&type=script&lang=js"
export * from "./InterconsultaForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=0ac11e51&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac11e51"]])

export default __exports__